/**
 * BE legacy enum value → canonical wire ``action_type``.
 *
 * The chat WS ``action_proposal`` frame ships the RAW BE enum value
 * (``create_event``), while the flattened console wire ships the canonical
 * string (``calendar_create_event`` — see BE ``action_proposal_flatten``,
 * ``ActionType.CREATE_EVENT → "calendar_create_event"``). Every FE surface
 * that routes on the type (dedicated preview cards, preview-owned fields)
 * must see ONE vocabulary, or a chat-born proposal silently falls back to
 * the generic card (observed live Aug 26, 2026: the calendar event card
 * rendered the raw RRULE text field instead of the recurrence picker).
 */
export function canonicalActionType(actionType: string): string {
  return actionType === "create_event" ? "calendar_create_event" : actionType;
}
